import React from 'react';
import { __ } from '@wordpress/i18n';


const SimpleLayout = ({ children }) => {
    return (
        <div className="wrapper">
            <div className="inner">
                <main>
                    {children}
                    <footer>
                        <p>{__('© 2025 HTR Bonifiche. Tutti i diritti riservati.', 'htr')}</p>
                    </footer>
                </main>
            </div>
        </div>
    )
}

export default SimpleLayout;